export default __webpack_public_path__ + "static/media/1.ce53ba1d.png";